export const VOLUME_SLICES = {
    INCLUSIVE:   'INCLUSIVE',
    EXCLUSIVE:   'EXCLUSIVE',
    RESIDENTIAL: 'RESIDENTIAL',
    BUSINESS:    'BUSINESS',
    FARMER:      'FARMER',
    DAIRY:       'DAIRY'
};